import { render } from "./BasicModal1b.vue?vue&type=template&id=7a7173c5"
import script from "./BasicModal1b.vue?vue&type=script&lang=js"
export * from "./BasicModal1b.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__